
document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('static-risk-warning');
  // provision for multiple elements: so it can be added to bottom-fixed elements
  const spacers = Array.from(document.getElementsByClassName('static-risk-warning-spacer'));

  if (!root || !spacers.length || !('ResizeObserver' in window)) {
    return;
  }

  const resizeObserver = new ResizeObserver((ev) => {
    const entry = ev[0];
    const height = (entry.borderBoxSize && entry.borderBoxSize.height)
      || entry.contentRect.height + 16; // hard-coded padding for fallback 'contentRect' property

    spacers.forEach((spacer) => {
      // eslint-disable-next-line no-param-reassign
      spacer.style.height = `${height}px`;
    });
  });

  resizeObserver.observe(root);
});
